var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagementLiability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.2,11.2c2.3,1.4,3.9,3.9,4.2,6.7c0.9,0.4,2,0.7,3.1,0.7c4.1,0,7.3-3.3,7.3-7.3c0-4.1-3.3-7.3-7.3-7.3C33.5,4,30.2,7.2,30.2,11.2z M25.4,26.2c4.1,0,7.3-3.3,7.3-7.3s-3.3-7.3-7.3-7.3S18,14.8,18,18.9S21.3,26.2,25.4,26.2z M28.5,26.7h-6.2c-5.2,0-9.4,4.2-9.4,9.4v7.6l0,0.1l0.5,0.2c4.9,1.5,9.2,2.1,12.8,2.1c6.9,0,10.9-2,11.1-2.1l0.5-0.2h0.1v-7.6C37.9,30.9,33.7,26.7,28.5,26.7z M40.6,19.1h-6.2c-0.1,2.5-1.1,4.7-2.8,6.3c4.6,1.4,8,5.6,8,10.7v2.3c6.1-0.2,9.6-2,9.8-2.1l0.5-0.2H50v-7.6C50,23.3,45.8,19.1,40.6,19.1z M12.5,18.6c1.4,0,2.8-0.4,3.9-1.1c0.4-2.3,1.6-4.4,3.4-5.8c0-0.1,0-0.3,0-0.4c0-4.1-3.3-7.3-7.3-7.3c-4.1,0-7.3,3.3-7.3,7.3C5.2,15.3,8.5,18.6,12.5,18.6z M19.1,25.4c-1.7-1.6-2.7-3.8-2.8-6.3c-0.2,0-0.5,0-0.7,0H9.4c-5.2,0-9.4,4.2-9.4,9.4v7.6l0,0.1l0.5,0.2c4,1.2,7.5,1.8,10.6,2v-2.3C11.1,31.1,14.5,26.8,19.1,25.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementLiability);
export default __webpack_public_path__ + "static/media/management-liability.3710e4745ef59d3f9de88569871fc54b.svg";
export { ForwardRef as ReactComponent };